import { render, staticRenderFns } from "./NewStocktakingView.vue?vue&type=template&id=e36753ae&"
import script from "./NewStocktakingView.vue?vue&type=script&lang=js&"
export * from "./NewStocktakingView.vue?vue&type=script&lang=js&"
import style0 from "./NewStocktakingView.vue?vue&type=style&index=0&id=e36753ae&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports